import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button } from "react-bootstrap";
import { applyFilters } from "../../../actions/crew-kanban";

const Recently = props => {
    const { isRequestingEg, isRecentlyUpdated } = props;
    return !isRequestingEg && <div className="ml-2 recently">
        <Button variant="outline-light" title="Equipment Groups updated in last 24Hrs"
            className={`btn-recently ${isRecentlyUpdated ? "selected" : ""}`}
            onClick={() => props.actions.applyFilters({ isRecentlyUpdated: !isRecentlyUpdated })}>
            Recently Updated
        </Button>
        {/*  {isRecentlyUpdated && <Button variant="link" className="ml-1 btn-recently-clear"
            onClick={() => props.actions.applyFilters({ isRecentlyUpdated: false })}>
            Clear
        </Button>} */}
    </div>;
};

const mapStateToProps = state => ({
    isRequestingEg: state.crewKanban.isRequestingEg,
    isRecentlyUpdated: state.crewKanban.filters.isRecentlyUpdated
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ applyFilters }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Recently);